import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type updateFamilyEventPath = operations['AdminEventController_updateEvent']['parameters']['path'];
type updateFamilyEventData = components['schemas']['UpdateEventDto'];
type updateFamilyEventHeaders =
  operations['AdminEventController_updateEvent']['parameters']['header'];

interface updateFamilyEventProps {
  path: updateFamilyEventPath;
  data: updateFamilyEventData;
  headers?: OmitGroupIdInHeader<updateFamilyEventHeaders>;
}

type updateFamilyEventResponse = unknown;

export async function updateFamilyEvent({
  path,
  data,
  headers,
}: updateFamilyEventProps): Promise<updateFamilyEventResponse | false> {
  const response = await authenticateRequest<updateFamilyEventResponse>({
    method: 'patch',
    url: `/api/v1/admin/events/${path.eventId}`,
    headers,
    data,
  });

  console.log('updateFamilyEvent', { response });
  return response;
}
